import { render, staticRenderFns } from "./SearchComplete.vue?vue&type=template&id=1b937be8&"
import script from "./SearchComplete.vue?vue&type=script&lang=js&"
export * from "./SearchComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports